<template>
  <div class="main-AboutUs backdrop" id="main-AboutUs">
    <div class="introduce">
      <p>执行-敢于担当，按规定时间，高质量地完成预定结果学习-始终保持学习心态，不断完善提升自我团队-思想统一，形成合力，量才而用，追求团队成功管理-增强大局观，双赢思维，注重沟通调研，形成方法论计划-合理规划，严谨有序，要事第一，黄金时间办要事</p>
      <p>&nbsp; &nbsp; &nbsp; &nbsp;品质-精心设计，注重细节，一次性把事做对</p>
      <p>&nbsp; &nbsp; &nbsp; &nbsp;道德-正直诚信，恪守、监督并打击损害公司利益的行为</p>
      <p>&nbsp; &nbsp; &nbsp; &nbsp;梦想-持之以恒、真正为实现互联网事业的梦想而奋斗，不为私心所困</p>
      <p>&nbsp; &nbsp; &nbsp; &nbsp;目标-坚持不懈地帮助客户提高生产力，提升自身社会品质原则-脚踏实地，实事求是，点滴创新，用数据说话</p>
      <p>&nbsp; &nbsp; &nbsp; &nbsp;道德-正直诚信，恪守、监督并打击损害公司利益的行为</p>
      <p>&nbsp; &nbsp; &nbsp; &nbsp;梦想-持之以恒、真正为实现互联网事业的梦想而奋斗，不为私心所困</p>
      <p>&nbsp; &nbsp; &nbsp; &nbsp;目标-坚持不懈地帮助客户提高生产力，提升自身社会品质原则-脚踏实地，实事求是，点滴创新，用数据说话</p>
    </div>
  </div>
</template>

<script>
    export default {
        name: "us_culture"
    }
</script>

<style scoped>
  p{
    width: 100%;
    margin: 10px 0;
  }
  /*关于我们开始*/
  .main-AboutUs{
    background-image: url(../assets/img/pic/pic_ABOUT.jpg);
    background-repeat:no-repeat;
  }
  .main-AboutUs .introduce{
    display: flex;
    flex-wrap:wrap;
    margin: 0.3rem 0.7rem 0 0.7rem;
    /*animation: 2s aircraft;*/
  }
  .main-AboutUs .introduce>div{
    width: 385px;
    flex-grow: 1;
    align-self:center;
  }
  .main-AboutUs .introduce>div:first-of-type{
    text-align: center;
  }
  .main-AboutUs .introduce img{
    width: 80%;
  }
  .main-AboutUs .introduce span{
    font-family: 微软雅黑;
    font-size: 14px;
    line-height: 200%;
    color: #5a5a5a;
  }
  /*关于我们结束*/

  /*新闻动态结束*/
  @media screen and (max-width: 1024px) {

    .msg div{
      width: 14rem;
      margin: auto;
    }
    .title_content{
      font-size: 1rem;

    }
    .title_msg{
      font-size: .3rem;
    }
  }
  @media screen and (max-width:768px){

    .title_content span{
      font-size: 12px;
    }
    .msg div{
      width: 100%;
    }
    .title_msg{
      width: 70%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/us_culture.vue